// `accountId` and `documentTypeId` are route identifiers: neither is echoed in the request body.
class RenameDocumentType {
	constructor(
		public readonly accountId: number,
		public readonly documentTypeId: number,
		public readonly label: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			label: this.label,
		};
	}
}

export default RenameDocumentType;
